import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { tryLoadAndStartRecorder } from "@alwaysmeticulous/recorder-loader";

import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { env } from "./configs/reexports";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

async function startApp() {
  const envName = env.name;

  function isProduction() {
    return envName === "prod";
  }

  if (!isProduction()) {
    await tryLoadAndStartRecorder({
      recordingToken: "lsFr24sbZuIEYhfCMAEhCXgSWj4H0zgaEtwAoDoz",
      isProduction: false,
    });
  }

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
